export default __webpack_public_path__ + "static/media/Spotify.ec2e9d4a.PNG";